export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "forecast.worker.7446b5698acd8a05e3bf.worker.js");
}
